module.exports = __webpack_public_path__ + "media/images/map_icons/Gymnastics-7fe07c3050a608675eb4505ef7826149.svg";